export default "__VITE_ASSET__Dl3k2vTj__"